import React, { useState } from "react";
import "./see-demo.css";
import playIcon from "../../../images/Agent Trust Images/assets/SeeDemo/play-icon.svg";
import useIntersectionObserver from "../customHooks/useIntersectionObserver";

export default function SeeDemo() {
  const [ref, isVisible] = useIntersectionObserver({ threshold: 0.1 });
  const [isPlaying, setIsPlaying] = useState(false);

  const playVideo = () => {
    setIsPlaying(true);
  };
  return (
    <section
      className={`see-demo-section ${isVisible ? "section-animation" : ""}`}
      ref={ref}
    >
      <div className="container">
        <div className="section-heading">
          <div className="heading-tag">
            <span>See In Action</span>
          </div>
          <div className="heading-description">
            <h2>Watch Our Agent Demo</h2>
          </div>
          <div
            className={`demo-video-wrapper ${
              isVisible ? "reveal-animation" : ""
            }`}
          >
            <div className={`demo-video ${isVisible ? "slide-animation" : ""}`}>
              <div>
                <div className="video-section-wrapper">
                  <div className={`${!isPlaying ? "video-section-outer" : ""}`}>
                    <div
                      className="video-section-inner"
                      style={{ backgroundImage: isPlaying ? "none" : "" }}
                    >
                      {isPlaying ? (
                        <iframe
                          title={`Introduction Video - ${Date.now()}`} // Unique title
                          src="https://www.youtube.com/embed/OtC_g3O4DFU?si=AXBFVnsjmeUCUhYy"
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        ></iframe>
                      ) : (
                        <div
                          className="video-section-button"
                          onClick={playVideo}
                        >
                          <img src={playIcon} alt="Video Icon" />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
